module.exports = {
      id: "login-google-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#login-google",
      toString: function () {
        return this.url;
      }
    }